import { SpaceInfo } from '../state/SpaceInfo';
import { CallCollectionsReorderItem } from './AppActionTypes';
import { isActionFactory } from './isActionFactory';
import { ReorderItemAction } from './ReorderItem';

export interface CallReorderItemAction extends ReorderItemAction {}

// this is the action calling the collections saga.
export function callCollectionsReorder(fromIndex: number, indexToMoveAfter: number, spaceInfo: SpaceInfo): CallReorderItemAction {
  return {
    type: CallCollectionsReorderItem,
    spaceInfo,
    fromIndex,
    indexToMoveAfter: indexToMoveAfter,
  };
}

export const isCallReorderItemAction = isActionFactory<CallReorderItemAction>(CallCollectionsReorderItem);